'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactCssThemr = require('react-css-themr');

var _identifiers = require('../../identifiers');

var _tinycolor = require('tinycolor2');

var _tinycolor2 = _interopRequireDefault(_tinycolor);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Icon = function (_React$Component) {
  _inherits(Icon, _React$Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          theme = _props.theme,
          icon = _props.icon,
          opaque = _props.opaque,
          middle = _props.middle,
          color = _props.color,
          size = _props.size,
          circle = _props.circle,
          iconClassName = _props.iconClassName,
          rotate = _props.rotate,
          className = _props.className,
          other = _objectWithoutProperties(_props, ['theme', 'icon', 'opaque', 'middle', 'color', 'size', 'circle', 'iconClassName', 'rotate', 'className']);

      var iconClass = (0, _classnames2['default'])(className, theme.icon, theme[color], theme[size], (_classNames = {}, _defineProperty(_classNames, theme.opaque, opaque), _defineProperty(_classNames, theme.middle, middle), _classNames), iconClassName);
      var rotateStyle = {};

      if (rotate) {
        rotateStyle.transform = 'rotate(' + rotate + 'deg)';
      }

      var plainIcon = _react2['default'].createElement('i', _extends({
        className: iconClass,
        style: rotateStyle
      }, other), icon);

      var circleStyle = {};

      if (circle) {
        circleStyle.backgroundColor = (0, _tinycolor2['default'])(circle.color).setAlpha(0.1);
        circleStyle.width = circle.width;
        circleStyle.height = circle.height;
        circleStyle.lineHeight = parseInt(circle.height) + 10 + 'px';
      }

      var circledIcon = _react2['default'].createElement('div', {
        className: theme.circle,
        style: circleStyle
      }, plainIcon);

      return circle ? circledIcon : plainIcon;
    }
  }]);

  return Icon;
}(_react2['default'].Component);

Icon.themeShape = {
  icon: _propTypes2['default'].string.isRequired,
  opaque: _propTypes2['default'].string.isRequired,
  tiny: _propTypes2['default'].string.isRequired,
  small: _propTypes2['default'].string.isRequired,
  regular: _propTypes2['default'].string.isRequired,
  large: _propTypes2['default'].string.isRequired,
  title2: _propTypes2['default'].string.isRequired,
  title1: _propTypes2['default'].string.isRequired,
  none: _propTypes2['default'].string.isRequired,
  black: _propTypes2['default'].string.isRequired,
  white: _propTypes2['default'].string.isRequired,
  grey: _propTypes2['default'].string.isRequired,
  primary: _propTypes2['default'].string.isRequired,
  success: _propTypes2['default'].string.isRequired,
  warning: _propTypes2['default'].string.isRequired,
  danger: _propTypes2['default'].string.isRequired,
  middle: _propTypes2['default'].string.isRequired
};
Icon.propTypes = {
  theme: _propTypes2['default'].shape(Icon.themeShape).isRequired,
  opaque: _propTypes2['default'].bool,
  middle: _propTypes2['default'].bool,
  iconClassName: _propTypes2['default'].string,
  rotate: _propTypes2['default'].number,
  circle: _propTypes2['default'].shape({
    color: _propTypes2['default'].string.isRequired,
    width: _propTypes2['default'].string.isRequired,
    height: _propTypes2['default'].string.isRequired
  }),
  color: _propTypes2['default'].oneOf(['none', 'black', 'white', 'grey', 'success', 'warning', 'danger', 'primary']).isRequired,
  size: _propTypes2['default'].oneOf(['icon', 'tiny', 'small', 'regular', 'large', 'title2', 'title1']).isRequired,
  icon: _propTypes2['default'].string.isRequired
};
Icon.defaultProps = {
  icon: 'face',
  size: 'icon',
  color: 'black'
};
exports['default'] = (0, _reactCssThemr.themr)(_identifiers.ICON)(Icon);
exports.Icon = Icon;